"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = exports.shouldHideArrow = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var css_1 = require("@emotion/css");
var react_popper_1 = require("react-popper");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var useDelayedTooltip_1 = require("./useDelayedTooltip");
var arrowHeight = 8;
var arrowWidth = 8;
var arrowStyles = function (selectedTheme, variant) {
    var themedBorderColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral90,
        dark: design_system_foundations_1.darkTheme.color.prussianBlue,
    });
    var borderColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBorderColor;
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    background: inherit;\n    visibility: hidden;\n\n    &::after {\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      background: inherit;\n      visibility: visible;\n      content: \"\";\n      transform: rotate(45deg);\n      border: 1px solid ", ";\n      z-index: -1;\n    }\n  "], ["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    background: inherit;\n    visibility: hidden;\n\n    &::after {\n      position: absolute;\n      width: 8px;\n      height: 8px;\n      background: inherit;\n      visibility: visible;\n      content: \"\";\n      transform: rotate(45deg);\n      border: 1px solid ", ";\n      z-index: -1;\n    }\n  "])), arrowWidth, arrowHeight, borderColor);
};
var containerStyles = function (size, zIndex, selectedTheme, variant) {
    var themedBackgroundColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral90,
        dark: design_system_foundations_1.darkTheme.color.prussianBlue,
    });
    var backgroundColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBackgroundColor;
    var themedBorderColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral90,
        dark: design_system_foundations_1.darkTheme.color.prussianBlue,
    });
    var borderColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBorderColor;
    return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: 1px solid ", ";\n    background-color: ", ";\n    border-radius: 8px;\n    z-index: ", ";\n    /* stylelint-disable-next-line */\n    padding: ", ";\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    min-width: 8px;\n    max-width: 560px;\n\n    &[data-popper-placement] > span[data-hide] {\n      display: none !important;\n      visibility: hidden !important;\n    }\n\n    &[data-popper-placement^=\"top\"] > span {\n      bottom: -3px;\n    }\n\n    &[data-popper-placement^=\"bottom\"] > span {\n      top: -4px;\n    }\n\n    &[data-popper-placement^=\"left\"] > span {\n      right: -3px;\n    }\n\n    &[data-popper-placement^=\"right\"] > span {\n      left: -4px;\n    }\n  "], ["\n    border: 1px solid ", ";\n    background-color: ", ";\n    border-radius: 8px;\n    z-index: ", ";\n    /* stylelint-disable-next-line */\n    padding: ", ";\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);\n    min-width: 8px;\n    max-width: 560px;\n\n    &[data-popper-placement] > span[data-hide] {\n      display: none !important;\n      visibility: hidden !important;\n    }\n\n    &[data-popper-placement^=\"top\"] > span {\n      bottom: -3px;\n    }\n\n    &[data-popper-placement^=\"bottom\"] > span {\n      top: -4px;\n    }\n\n    &[data-popper-placement^=\"left\"] > span {\n      right: -3px;\n    }\n\n    &[data-popper-placement^=\"right\"] > span {\n      left: -4px;\n    }\n  "])), borderColor, backgroundColor, zIndex, size === 'md' ? "".concat(design_system_foundations_1.theme.spacing.px8, " ").concat(design_system_foundations_1.theme.spacing.px12) : "".concat(design_system_foundations_1.theme.spacing.px4, " ").concat(design_system_foundations_1.theme.spacing.px8));
};
var contentStyles = function (selectedTheme, variant) {
    var themedBackgroundColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral90,
        dark: design_system_foundations_1.darkTheme.color.prussianBlue,
    });
    var backgroundColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBackgroundColor;
    return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    border-radius: 8px;\n    height: 100%;\n    position: relative;\n    width: 100%;\n    word-break: break-word;\n    z-index: 1;\n  "], ["\n    background: ", ";\n    border-radius: 8px;\n    height: 100%;\n    position: relative;\n    width: 100%;\n    word-break: break-word;\n    z-index: 1;\n  "])), backgroundColor);
};
var gridStyles = function (useInlineTitle) { return (0, css_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: 8px;\n  grid-auto-flow: ", ";\n"], ["\n  display: grid;\n  grid-gap: 8px;\n  grid-auto-flow: ", ";\n"])), useInlineTitle ? 'column' : 'row'); };
var renderTooltipContent = function (_a) {
    var element = _a.element, type = _a.type, testId = _a.testId;
    var font = type === 'title' ? 'metadataStrong' : 'metadata';
    var dataTestId = testId ? "".concat(testId, "-").concat(type) : undefined;
    return (react_1.default.createElement(design_system_typography_1.Text, { font: font, color: "white", "data-testid": dataTestId }, element));
};
var arrowOffsetMinimum = 8;
var shouldHideArrow = function (_a) {
    var placement = _a.placement, _b = _a.currentPosition, x = _b.x, y = _b.y, centerOffset = _b.centerOffset, width = _a.width, height = _a.height;
    if (centerOffset !== 0) {
        return true;
    }
    switch (placement) {
        // if the x position of the arrow is within a threshold of the left edge of the tooltip, hide the arrow
        case 'top-start':
        case 'bottom-start':
            return x ? x < arrowOffsetMinimum : false;
        // if the x position is within a threshold of the right edge of the tooltip, hide the arrow
        case 'top-end':
        case 'bottom-end':
            return x && width ? width - (x + arrowWidth) < arrowOffsetMinimum : false;
        // if the y position is within a threshold of the top of the tooltip, hide the arrow
        case 'left-start':
        case 'right-start':
            return y ? y < arrowOffsetMinimum : false;
        // if the y position is within a threshold of the bootom of the tooltip, hide the arrow
        case 'left-end':
        case 'right-end':
            return y && height ? height - (y + arrowWidth) < arrowOffsetMinimum : false;
        // for all other placements, show the arrow
        default:
            return false;
    }
};
exports.shouldHideArrow = shouldHideArrow;
var applyArrowHide = {
    name: 'applyArrowHide',
    enabled: true,
    phase: 'write',
    fn: function (_a) {
        var state = _a.state;
        var arrow = state.elements.arrow, placement = state.placement, modifiersData = state.modifiersData, popper = state.rects.popper;
        if (arrow) {
            if ((0, exports.shouldHideArrow)({ placement: placement, currentPosition: modifiersData.arrow, height: popper.height, width: popper.width })) {
                arrow.setAttribute('data-hide', '');
            }
            else {
                arrow.removeAttribute('data-hide');
            }
        }
    },
};
exports.Tooltip = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var _c = _a.enabled, enabled = _c === void 0 ? true : _c, children = _a.children, className = _a.className, _d = _a.offset, offset = _d === void 0 ? [0, 8] : _d, _e = _a.placement, placement = _e === void 0 ? 'top' : _e, testId = _a.testId, _f = _a.interactive, interactive = _f === void 0 ? false : _f, _g = _a.isDelayed, isDelayed = _g === void 0 ? false : _g, userStyles = _a.style, title = _a.title, body = _a.body, _h = _a.hasArrow, hasArrow = _h === void 0 ? true : _h, _j = _a.useInlineTitle, useInlineTitle = _j === void 0 ? false : _j, openDelay = _a.openDelay, closeDelay = _a.closeDelay, _k = _a.size, size = _k === void 0 ? 'md' : _k, _l = _a.zIndex, zIndex = _l === void 0 ? design_system_foundations_1.theme.zIndex.tooltip : _l, fixed = _a.fixed, contentClassName = _a.contentClassName, variant = _a.variant, rest = __rest(_a, ["enabled", "children", "className", "offset", "placement", "testId", "interactive", "isDelayed", "style", "title", "body", "hasArrow", "useInlineTitle", "openDelay", "closeDelay", "size", "zIndex", "fixed", "contentClassName", "variant"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var _m = (0, react_1.useState)(false), isOpen = _m[0], setIsOpen = _m[1];
    var _o = (0, react_1.useState)(null), popperElement = _o[0], setPopperElement = _o[1];
    var _p = (0, react_1.useState)(null), arrowElement = _p[0], setArrowElement = _p[1];
    var _q = (0, react_1.useState)(null), referenceElement = _q[0], setReferenceElement = _q[1];
    var _r = (0, useDelayedTooltip_1.useDelayedTooltip)({
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        popperElement: popperElement,
        arrowElement: arrowElement,
        referenceElement: referenceElement,
        isInteractive: interactive,
        openDelay: openDelay,
        closeDelay: closeDelay,
    }), startDelayedOpen = _r.startDelayedOpen, startDelayedClose = _r.startDelayedClose;
    var _s = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        strategy: fixed ? 'fixed' : 'absolute',
        placement: placement,
        modifiers: [
            { name: 'arrow', options: { element: arrowElement } },
            { name: 'offset', options: { offset: offset } },
            applyArrowHide,
        ],
    }), styles = _s.styles, attributes = _s.attributes;
    var showTooltip = function () {
        if (isDelayed) {
            startDelayedOpen();
        }
        else {
            setIsOpen(true);
        }
    };
    var hideTooltip = function () {
        if (isDelayed || interactive) {
            startDelayedClose();
        }
        else {
            setIsOpen(false);
        }
    };
    var classes = (0, css_1.cx)(containerStyles(size, zIndex, selectedTheme, variant), className, 'ds-tooltip');
    var actualPlacement = (_b = attributes === null || attributes === void 0 ? void 0 : attributes.popper) === null || _b === void 0 ? void 0 : _b['data-popper-placement'];
    var setTooltipEvents = function (componentChildren) {
        var events = {};
        var showEvents = ['onMouseOver', 'onFocus'];
        var hideEvents = ['onMouseLeave', 'onBlur'];
        __spreadArray(__spreadArray([], showEvents, true), hideEvents, true).forEach(function (event) {
            // eslint-disable-next-line no-prototype-builtins
            if (componentChildren.props.hasOwnProperty(event) && typeof componentChildren.props[event] === 'function') {
                var setTooltipState_1 = showEvents.includes(event) ? showTooltip : hideTooltip;
                events[event] = function (evt) {
                    componentChildren.props[event](evt);
                    setTooltipState_1();
                };
            }
            else {
                events[event] = showEvents.includes(event) ? showTooltip : hideTooltip;
            }
        });
        return events;
    };
    var treatedChildren = typeof children === 'string' ? react_1.default.createElement('span', {}, children) : children;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.isValidElement(treatedChildren) &&
            react_1.default.cloneElement(treatedChildren, __assign({ 
                // @ts-ignore
                ref: function (node) {
                    setReferenceElement(node);
                    // Call the original ref, if any
                    if (typeof ref === 'function') {
                        ref(node);
                    }
                    else if (ref !== null) {
                        ref.current = node;
                    }
                } }, setTooltipEvents(treatedChildren))),
        enabled &&
            isOpen &&
            react_dom_1.default.createPortal(react_1.default.createElement("div", __assign({ onMouseOver: showTooltip, onMouseLeave: hideTooltip, onFocus: showTooltip, onBlur: hideTooltip, "data-popper-placement": placement, className: classes, ref: setPopperElement, style: __assign(__assign({}, styles.popper), userStyles), "data-testid": testId }, attributes.popper, rest),
                react_1.default.createElement("div", { className: (0, css_1.cx)(contentStyles(selectedTheme, variant), contentClassName) },
                    react_1.default.createElement("div", { className: gridStyles(useInlineTitle), "data-testid": testId && "".concat(testId, "-content") },
                        title && renderTooltipContent({ element: title, type: 'title', testId: testId }),
                        body && renderTooltipContent({ element: body, type: 'body', testId: testId }))),
                actualPlacement && hasArrow && (react_1.default.createElement("span", { "data-popper-placement": actualPlacement, className: arrowStyles(selectedTheme, variant), ref: setArrowElement, "data-testid": testId && "".concat(testId, "-arrow"), style: styles.arrow }))), document.body)));
});
exports.Tooltip.displayName = 'Tooltip';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
